import { InjectionToken, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { map, catchError, shareReplay } from 'rxjs/operators';
import { AD_BLOCK_LOADER, FloAdBlockModule } from '@flosportsinc/ng-ad-block';
import { of } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
const AD_BLOCK_PING_URL = new InjectionToken('fs.ab.ping-url');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const returnFalse = (/**
 * @return {?}
 */
() => false);
/** @type {?} */
const returnTrusObs = (/**
 * @return {?}
 */
() => of(true));
/**
 * @param {?} http
 * @param {?} pingUrl
 * @return {?}
 */
function defaultBrowserLoader(http, pingUrl) {
    /** @type {?} */
    const func = http.get(pingUrl).pipe(map(returnFalse), catchError(returnTrusObs), shareReplay(1));
    return func;
}
class FloAdBlockBrowserModule {
    /**
     * @param {?} url
     * @return {?}
     */
    static usingUrl(url) {
        return {
            ngModule: FloAdBlockBrowserModule,
            providers: [
                {
                    provide: AD_BLOCK_PING_URL,
                    useValue: url
                },
                {
                    provide: AD_BLOCK_LOADER,
                    useFactory: defaultBrowserLoader,
                    deps: [HttpClient, AD_BLOCK_PING_URL]
                }
            ]
        };
    }
}
FloAdBlockBrowserModule.ɵfac = function FloAdBlockBrowserModule_Factory(t) { return new (t || FloAdBlockBrowserModule)(); };
FloAdBlockBrowserModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FloAdBlockBrowserModule });
FloAdBlockBrowserModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [FloAdBlockModule, HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FloAdBlockBrowserModule, [{
        type: NgModule,
        args: [{
                imports: [FloAdBlockModule, HttpClientModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FloAdBlockBrowserModule, { imports: function () { return [FloAdBlockModule, HttpClientModule]; } }); })();

export { AD_BLOCK_PING_URL, FloAdBlockBrowserModule, defaultBrowserLoader };

